export const getShouldRenderUserNavigation = (pathname: string, organizationId?: number) => {
	const pathnameArray = pathname.split("/");
	const possibleOrganizationIdFromPathname = pathnameArray[1];

	return !organizationId && (isNaN(Number(possibleOrganizationIdFromPathname)) || pathname === "/");
};
